(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-video-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    const wrapper = document.querySelector(
      `[id^="shopify-block-{{ block.id }}"] .product-vc__wrapper, .product-vc__wrapper:has([id="shopify-block-{{ block.id }}"])`
    );

    /* fallback: find by unique block id on the root element */
    const root = document.getElementById('shopify-block-{{ block.id }}');
    if (!root) return;

    const track = root.querySelector('[data-vc-track]');
    const prevBtn = root.querySelector('[data-vc-prev]');
    const nextBtn = root.querySelector('[data-vc-next]');
    if (!track || !prevBtn || !nextBtn) return;

    const itemWidth = () => {
      const item = track.querySelector('.product-vc-item');
      return item ? item.offsetWidth + 10 : 182;
    };

    const update = () => {
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      prevBtn.toggleAttribute('data-hidden', atStart);
      nextBtn.toggleAttribute('data-hidden', atEnd);
    };

    prevBtn.addEventListener('click', () =>
      track.scrollBy({ left: -itemWidth() * 2, behavior: 'smooth' })
    );
    nextBtn.addEventListener('click', () =>
      track.scrollBy({ left: itemWidth() * 2, behavior: 'smooth' })
    );
    track.addEventListener('scroll', update, { passive: true });
    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('[data-consent-checkbox]');
    if (!checkbox) return;
    const form = checkbox.closest('form');
    if (!form) return;
    const submitButton = form.querySelector('[data-consent-submit]');
    if (!submitButton) return;
    submitButton.disabled = !checkbox.checked;
  });
  } catch(e) { console.error(e); }
})();

})();
